import React from 'react'
import styled from 'styled-components'
import Button from '../button'
import ThreeDotsLoader from './three-dots-loader'

const AnimationWrapperElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

function LoadingButton({ isLoading, children, ...restOfProps }) {
  return (
    <Button {...restOfProps}>
      {isLoading ? (
        <AnimationWrapperElement>
          <ThreeDotsLoader />
        </AnimationWrapperElement>
      ) : (
        children
      )}
    </Button>
  )
}

export default LoadingButton
